import { render, staticRenderFns } from "./SupportRequestSearch.vue?vue&type=template&id=56eedfef&"
import script from "./SupportRequestSearch.vue?vue&type=script&lang=js&"
export * from "./SupportRequestSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports